export default __webpack_public_path__ + "static/media/BDI.155596e8.svg";